export default {
    payText: 'Pay to see company contacts',
    loginText: 'Log in to see company contacts'
};
